import React, { useEffect } from "react";
import "./login.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LanguageCom from "Components/LanguageCom";
import { useNavigate } from "react-router-dom";

import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";
function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [state, setState] = useState(false);

  const islogin = useSelector((state) => state.islogin);

  function Login() {
    dispatch({
      type: "LOGIN_USER",
      payload: {
        username: username,
        password: password,
      },
    });
  }

  useEffect(() => {
    if (islogin) {
      navigate("/");
    }
  }, [islogin]);

  return (
    <section className="bg-fixed-full h-screen w-full">
      <LanguageCom />
      <div className="-mt-14 flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div class=" w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div class="p-6 space-y-4 md:space-y-6 sm:p-8 ">
            <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              {t("Sign in to your account")}
            </h1>
            <form
              class="space-y-4 md:space-y-6"
              onSubmit={(e) => {
                e.preventDefault();
                Login();
              }}
            >
              <div>
                <label
                  for="username"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  {t("User Name")}
                </label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  onChange={(e) => setUsername(e.target.value)}
                  value={username}
                  class="bg-gray-50 dark:border-white border border-primary dark:bg-gray-700 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5  dark:placeholder-gray-400 dark:text-white outline-none"
                  required={true}
                />
              </div>
              <div>
                <label
                  for="password"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  {t("Password")}
                </label>
                <div className="bg-gray-50 mb-10 flex flex-row justify-between dark:border-white border border-primary dark:bg-gray-700 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600  items-center w-full p-2.5  dark:placeholder-gray-400 dark:text-white outline-none ">
                  <input
                    type={state ? "text" : "password"}
                    name="password"
                    id="password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    className="bg-transparent w-full outline-none "
                    required={true}
                  />
                  {state ? (
                    <IoMdEye
                      className="text-xl cursor-pointer"
                      onClick={() => setState(!state)}
                    />
                  ) : (
                    <IoMdEyeOff
                      className="text-xl cursor-pointer"
                      onClick={() => setState(!state)}
                    />
                  )}
                </div>
              </div>

              <button
                type="submit"
                class="w-full  text-white bg-primary hover:bg-opacity-80 duration-300  focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
              >
                {t("Sign in")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Login;
